import PageToolBar from '../../../components/PageToolBar';
import React, {useEffect, useState} from 'react';
import {
  ErrorMessage,
  FormGroup,
  FormItemButton,
  FormItemGroup,
  Input,
  RequireMarker,
} from '../../../../../components/form-items';
import {useFieldArray, useFormContext} from 'react-hook-form';
import {
  Bank,
  IncomeTaxRegistrationUnit,
  PayrollCompanySetting,
} from '../../../api/types';
import {IconButton} from '../../../../../components/Button';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlusCircle} from '@fortawesome/pro-light-svg-icons';
import Block from './block';
import {v4 as uuid} from 'uuid';
import {DeleteDialog} from '../../../components/Dialog';

const Banks = function () {
  const {
    control,
    register,
    errors,
    getValues,
    formState: {isSubmitted},
    trigger,
  } = useFormContext<PayrollCompanySetting>();
  const [deleteIdx, setDeleteIdx] = useState<null | number>(null);
  const {fields, append, remove} = useFieldArray<Bank, string>({
    name: 'banks',
    control,
  });

  useEffect(() => {
    if (fields.length === 0) {
      append({bankId: uuid()});
    }
  }, [fields]);
  return (
    <div>
      <PageToolBar pageTitle={'薪資帳戶銀行'} />
      <Block>
        {fields.map((field, idx) => (
          <FormGroup
            data-test-id={`bank-${idx}`}
            columnTemplates={'80px 175px 64px'}
            key={field.id}
            className={
              'border-b border-b-[#e9eced] pb-5 mb-5 last:border-0 last:mb-0'
            }
          >
            <input
              type={'hidden'}
              value={0}
              ref={register()}
              name={`banks.${idx}.transferFileType`}
            />
            <input
              type={'hidden'}
              ref={register()}
              name={`banks.${idx}.bankId`}
              defaultValue={field.bankId}
              data-test-id={'bank-id'}
            />
            <FormItemGroup>
              <label htmlFor={`banks.${idx}.code`}>
                銀行代碼 <RequireMarker />
              </label>
              <Input
                data-test-id={'bank-code'}
                name={`banks.${idx}.code`}
                id={`banks.${idx}.code`}
                ref={register({
                  required: '必填欄位',
                  pattern: {
                    value: /^\d{3}$/,
                    message: '限制為3碼數字',
                  },
                  validate: v => {
                    const {banks} = getValues();
                    return banks.some(
                      (bank, compareIdx: number) =>
                        bank.code === v && compareIdx !== idx,
                    )
                      ? '銀行代碼不可重覆'
                      : true;
                  },
                })}
                maxLength={3}
                error={errors?.banks && errors.banks[idx]?.code?.message}
                defaultValue={field.code}
                placeholder={'001'}
                onBlur={e => {
                  if (isSubmitted) {
                    trigger(
                      fields
                        .map((f, fIdx) => `banks.${fIdx}.code`)
                        .filter((f, fIdx) => fIdx !== idx),
                    );
                  }
                }}
              />
              <ErrorMessage>
                {errors?.banks && errors.banks[idx]?.code?.message}
              </ErrorMessage>
            </FormItemGroup>
            <FormItemGroup>
              <label htmlFor={`banks.${idx}.name`}>
                銀行名稱 <RequireMarker />
              </label>
              <Input
                data-test-id={'bank-name'}
                name={`banks.${idx}.name`}
                id={`banks.${idx}.name`}
                ref={register({
                  required: '必填欄位',
                  maxLength: {
                    value: 10,
                    message: '字數限制為 10 字',
                  },
                })}
                maxLength={10}
                error={errors?.banks && errors.banks[idx]?.name?.message}
                defaultValue={field.name}
                placeholder={'中央信託'}
              />
              <ErrorMessage>
                {errors?.banks && errors.banks[idx]?.name?.message}
              </ErrorMessage>
            </FormItemGroup>
            <FormItemButton>
              {fields.length !== 1 && (
                <IconButton
                  onClick={e => {
                    e.preventDefault();
                    setDeleteIdx(idx);
                  }}
                  data-test-id={'remove-btn'}
                >
                  <FontAwesomeIcon
                    icon={['fal', 'trash-alt']}
                    style={{fontSize: 16}}
                  />
                </IconButton>
              )}
              {idx === fields.length - 1 && (
                <IconButton
                  onClick={() => append({bankId: uuid()})}
                  data-test-id={'add-btn'}
                >
                  <FontAwesomeIcon icon={faPlusCircle} style={{fontSize: 16}} />
                </IconButton>
              )}
            </FormItemButton>
          </FormGroup>
        ))}
        <DeleteDialog
          isOpen={deleteIdx !== null}
          onCancel={() => setDeleteIdx(null)}
          onConfirm={() => {
            if (deleteIdx !== null) {
              remove(deleteIdx);
            }

            setDeleteIdx(null);
          }}
        />
      </Block>
    </div>
  );
};

export default Banks;
